// extracted by mini-css-extract-plugin
export default {"r_l":"dceea9d233 _670e4b7493","t":"_6306afa7da"};